module.exports = __webpack_public_path__ + "img/zibubaojian.a8462cd2.png";